import React, { Component } from "react"
import { Link } from "react-router-dom"
import * as endpoint from "../../constants/Endpoints"
import * as path from "../../constants/Paths"
import LoginLink from "./loginLink"
import config from "react-global-configuration"
import SiteHeader from "../../../styleguide/js/components/site-header"

class MenuBar extends Component {
  constructor(props) {
    super(props)
    this.containerRef = React.createRef()

    this.state = {
      isSearchActive: false,
      isMobileMenuActive: false,
      isLanguageActive: false,
      isMobileLanguageActive: false,
      isMobileLoginDropdownActive: false,
      isLoginActive: false,
    }
  }

  componentDidMount() {
    new SiteHeader({ el: this.containerRef.current })
  }

  handleSearchToggle = () => {
    this.setState({ isSearchActive: !this.state.isSearchActive })
  }

  handleMobileMenuToggle = () => {
    this.setState({ isMobileMenuActive: !this.state.isMobileMenuActive })
  }

  handleLanguageToggle = () => {
    this.setState({ isLanguageActive: !this.state.isLanguageActive })
  }
  handleMobileLanguageToggle = () => {
    this.setState({ isMobileLanguageActive: !this.state.isMobileLanguageActive })
  }
  handleLoginDropdownToggle = () => {
    this.setState({ isLoginActive: !this.state.isLoginActive })
  }

  handleMobileLoginDropdownToggle = () => {
    this.setState({ isMobileLoginDropdownActive: !this.state.isMobileLoginDropdownActive })
  }
  handleLogout = () => {
    this.props.handleLogOut()
    this.setState({ isMobileMenuActive: false })
  }

  handleLanguageSelection = (lang) => {
    let pathname = this.props.location.pathname
    const search = this.props.location.search
    if (lang === "da") {
      if (pathname.includes("en")) {
        pathname = pathname.split("en")[1]
      }
    } else {
      pathname = `/${lang}${this.props.location.pathname}`
    }
    window.location.assign(`${pathname}${search}`)
  }

  render() {
    const { userAccountDetails } = this.props
    const { isSearchActive, isLanguageActive, isLoginActive, isMobileMenuActive, isMobileLanguageActive, isMobileLoginDropdownActive } = this.state
    const textKeys = config.get("textKeys.progressIndicator") || {}
    const headerMenuTextKeys = config.get("textKeys.headerMenu") || {}
    const headerMenu = config.get("headerMenu")
    return (
      <div className="site-header-wrapper">
        <header className="site-header js--site-header" ref={this.containerRef}>
          <nav className="main-navigation ">
            <div className={`main-navigation--mobile js--mobile-navigation ${isMobileMenuActive ? "is-active is-fixed" : ""}`}>
              <div className="main-navigation--mobile__top">
                <a className="button button--nav button--logo" href="/">
                  <span className="text">Cph</span>
                  <span className="icon">
                    <svg className="svg-icon svg-icon--logo-tight">
                      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-logo-tight">
                        &nbsp;
                      </use>
                    </svg>
                  </span>
                </a>
                <button className="button button--toggle js--navigation-toggle" onClick={() => this.handleMobileMenuToggle()}>
                  <span className="icon">
                    <svg className="svg-icon svg-icon--burgermenu">
                      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-burgermenu">
                        &nbsp;
                      </use>
                    </svg>
                  </span>
                  <span className="icon2">
                    <svg className="svg-icon svg-icon--close-new">
                      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                        &nbsp;
                      </use>
                    </svg>
                  </span>
                  <span className="text">{headerMenuTextKeys.menu || "Menu"}</span>
                </button>
              </div>
              <ul className={`main-navigation--mobile__list js--navigation-inner ${isMobileMenuActive ? "is-active" : ""}`}>
                <li className="main-navigation__item">
                  <div className="search search--mobile">
                    <form name="searchForm" action="https://info.parkering.cph.dk/s%C3%B8g?">
                      <div className="search__field">
                        <input type="text" name="q" id="q" placeholder={headerMenuTextKeys.searchPlaceholder1 || "Søg på alt muligt..."} />
                      </div>
                    </form>
                  </div>
                </li>

                {headerMenu.map((element, index) => {
                  return (
                    <li className="main-navigation__item" key={index}>
                      <a className="button button--nav" href={element.link}>
                        <span className="text">{element.displayName}</span>
                      </a>
                    </li>
                  )
                })}
                <li className="main-navigation__item">
                  <Link
                    to={path.AMMEND_SEARCH()}
                    className="button button--nav"
                    onClick={() => this.props.clearBookingContext(() => this.handleMobileMenuToggle())}
                  >
                    <span className="text">{headerMenuTextKeys.changeBooking || "Ændre booking"} </span>
                  </Link>
                </li>

                <li
                  className={`main-navigation__item main-navigation__item--bottom main-navigation__item--user js--has-dropdown ${
                    isMobileLoginDropdownActive ? "is-dropped" : ""
                  }`}
                  onClick={() => this.handleMobileLoginDropdownToggle()}
                >
                  {userAccountDetails ? (
                    userAccountDetails.ContactDetails ? (
                      <React.Fragment>
                        <button className="button button--nav js--dropdown-trigger">
                          <span className="text">
                            <span className="name">
                              {userAccountDetails.ContactDetails.FirstName || userAccountDetails.ContactDetails.LastName
                                ? userAccountDetails.ContactDetails.FirstName + " " + userAccountDetails.ContactDetails.LastName
                                : userAccountDetails.EmailAddress}
                            </span>
                          </span>
                          <span className="icon">
                            <svg className="svg-icon svg-icon--arrowdropdown-white">
                              <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-arrowdropdown-white" />
                            </svg>
                          </span>
                        </button>
                        <div className={`dropdown dropdown--user  ${isMobileLoginDropdownActive ? "is-active" : ""}`}>
                          <ul className="dropdown__list">
                            <li className="dropdown__item">
                              <a className="button" href="/min-side">
                                <span className="text">{headerMenuTextKeys.myPage || "Min side"}</span>
                              </a>
                            </li>
                            <li className="dropdown__item">
                              <a className="button" href="/cph-advantage/om-cph-advantage">
                                <span className="text">{headerMenuTextKeys.aboutAdvantage || "Om Advantage"}</span>
                              </a>
                            </li>
                            <li className="dropdown__item">
                              <button className="button" onClick={() => this.handleLogout()}>
                                <span className="text">{textKeys.logout || "Log ud"}</span>
                                <span className="icon">
                                  <svg className="svg-icon svg-icon--login">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-login" />
                                  </svg>
                                </span>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </React.Fragment>
                    ) : (
                      <div className="button button--nav">
                        <span className="text">{textKeys.crmOffline || "Sorry CRM is offline ..."}</span>
                      </div>
                    )
                  ) : (
                    <LoginLink
                      {...this.props}
                      loginurl={endpoint.ACCOUNT_LOGIN()}
                      linkClassName={"button button--nav js--dropdown-trigger"}
                      spanClassName={"text"}
                      linkText={headerMenuTextKeys.login || "Log ind"}
                    />
                  )}
                </li>
                <li
                  className={`main-navigation__item main-navigation__item--bottom main-navigation__item--language js--has-dropdown ${
                    isMobileLanguageActive ? "is-dropped" : ""
                  }`}
                >
                  <button className="button button--nav js--dropdown-trigger" onClick={() => this.handleMobileLanguageToggle()}>
                    <span className="text">{endpoint.locale() === "da" ? "Dansk" : "English"}</span>
                    <span className="icon">
                      <svg className="svg-icon svg-icon--arrowdropdown-white">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-arrowdropdown-white" />
                      </svg>
                    </span>
                  </button>
                  <div className={`dropdown dropdown--language ${isMobileLanguageActive ? "is-active" : ""}`} data-select="true">
                    <ul className="dropdown__list">
                      <li className="dropdown__item">
                        <button className="button" onClick={() => this.handleLanguageSelection("en")}>
                          <span className="text">{headerMenuTextKeys.english || "English"}</span>
                          <span className="icon">
                            <svg className="svg-icon svg-icon--checkmark">
                              <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-checkmark" />
                            </svg>
                          </span>
                        </button>
                      </li>
                      <li className="dropdown__item">
                        <button className="button" onClick={() => this.handleLanguageSelection("da")}>
                          <span className="text">{headerMenuTextKeys.danish || "Dansk"}</span>
                          <span className="icon">
                            <svg className="svg-icon svg-icon--checkmark">
                              <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-checkmark" />
                            </svg>
                          </span>
                        </button>
                      </li>
                      {/* // removed swedish - PAR-308
                    <li className="dropdown__item"> 
                      <a className="button" onClick={() => this.handleLanguageSelection('en')}>
                        <span className="text">{headerMenuTextKeys.swedish || "Svenska"}</span>
                        <span className="icon">
                          <svg className="svg-icon svg-icon--checkmark">
                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-checkmark" />
                          </svg>
                        </span>
                      </a>
                    </li> */}
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
            <div className="main-navigation--desktop">
              <ul className="main-navigation--desktop__main">
                <li className="main-navigation__item">
                  <a className="button button--nav button--logo" href="/">
                    <span className="text">Cph </span> {/*inner html seems unneccesary */}
                    <span className="icon">
                      <svg className="svg-icon svg-icon--logo-tight">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-logo-tight">
                          &nbsp;
                        </use>
                      </svg>
                    </span>
                  </a>
                </li>
                {headerMenu.map((element, index) => {
                  return (
                    <li className="main-navigation__item" key={index}>
                      <a className="button button--nav" href={element.link}>
                        <span className="text">{element.displayName}</span>
                      </a>
                    </li>
                  )
                })}
              </ul>
              <ul className="main-navigation--desktop__aux">
                <li className="main-navigation__item">
                  <Link to={path.AMMEND_SEARCH() + "?"} onClick={() => this.props.clearBookingContext()} className="button button--nav">
                    <span className="text">{headerMenuTextKeys.changeBooking || "Ændre booking"}</span>
                  </Link>
                </li>
                {userAccountDetails ? (
                  userAccountDetails.ContactDetails ? (
                    <li className={`main-navigation__item main-navigation__item--user js--has-dropdown ${isLoginActive ? "is-dropped" : ""}`}>
                      <button className="button button--nav js--dropdown-trigger" onClick={() => this.handleLoginDropdownToggle()}>
                        <span className="text">
                          <span className="name">
                            {userAccountDetails.ContactDetails.FirstName || userAccountDetails.ContactDetails.LastName
                              ? userAccountDetails.ContactDetails.FirstName + " " + userAccountDetails.ContactDetails.LastName
                              : userAccountDetails.EmailAddress}
                          </span>
                        </span>
                        <span className="icon">
                          <svg className="svg-icon svg-icon--arrowdropdown-white">
                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowdropdown-white">
                              &nbsp;
                            </use>
                          </svg>
                        </span>
                      </button>
                      <div className={`dropdown dropdown--language ${isLoginActive ? "is-active" : ""}`}>
                        <ul className="dropdown__list js--dropdown-list" data-dropdowntargetid={2}>
                          <li className="dropdown__item" onClick={() => this.handleLogout()}>
                            <button className="button">
                              <span className="text">{textKeys.logout || "Log ud"}</span>
                              <span className="icon">
                                <svg className="svg-icon svg-icon--checkmark">
                                  <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-checkmark">
                                    &nbsp;
                                  </use>
                                </svg>
                              </span>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </li>
                  ) : (
                    <li className="main-navigation__item main-navigation__item--user">
                      <div className="button button--nav">
                        <span className="text">{textKeys.crmOffline || "Sorry CRM is offline ..."}</span>
                      </div>
                    </li>
                  )
                ) : (
                  <li className="main-navigation__item main-navigation__item--user">
                    <LoginLink
                      {...this.props}
                      loginurl={endpoint.ACCOUNT_LOGIN()}
                      linkClassName={"button button--nav"}
                      spanClassName={"text"}
                      linkText={"Log ind"}
                    />
                  </li>
                )}

                {/* <li className="main-navigation__item main-navigation__item--user">
              {userAccountDetails ?
                (userAccountDetails.ContactDetails ?
                  <React.Fragment>
                    <div className="button button--nav" href="/min-side" >
                      <span className="text">Mine profile</span>
                    </div>
                    <a className="button button--nav"
                      onClick={this.props.handleLogOut}
                    >
                      <span className="text">{textKeys.logout || "Log ud"}</span>
                    </a>
                  </React.Fragment>
                  :
                  <div className="button button--nav" >
                    <span className="text">{textKeys.crmOffline || "Sorry CRM is offline ..."}</span>
                  </div>
                ) :
                <LoginLink
                  {... this.props}
                  linkClassName={"button button--nav"}
                  spanClassName={"text"}
                  linkText={"Log ind"}
                />
              }
              </li> */}
                <li className={`main-navigation__item  js--has-dropdown ${isLanguageActive ? "is-dropped" : ""}`}>
                  <button className="button button--nav js--dropdown-trigger" onClick={() => this.handleLanguageToggle()}>
                    <span className="text">{endpoint.locale() === "da" ? "Dansk" : "English"}</span>
                    <span className="icon">
                      <svg className="svg-icon svg-icon--arrowdropdown-white">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowdropdown-white">
                          &nbsp;
                        </use>
                      </svg>
                    </span>
                  </button>
                  <div className={`dropdown dropdown--language ${isLanguageActive ? "is-active" : ""}`}>
                    <h6>{headerMenuTextKeys.language || "Language"}</h6>
                    <ul className="dropdown__list js--dropdown-list" data-dropdowntargetid={2}>
                      <li className="dropdown__item" onClick={() => this.handleLanguageSelection("da")}>
                        <button className="button">
                          <span className="text">{headerMenuTextKeys.danish || "Dansk"}</span>
                          <span className="icon">
                            <svg className="svg-icon svg-icon--checkmark">
                              <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-checkmark">
                                &nbsp;
                              </use>
                            </svg>
                          </span>
                        </button>
                      </li>
                      <li className="dropdown__item" onClick={() => this.handleLanguageSelection("en")}>
                        <button className="button">
                          <span className="text">{headerMenuTextKeys.english || "English"}</span>
                          <span className="icon">
                            <svg className="svg-icon svg-icon--checkmark">
                              <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-checkmark">
                                &nbsp;
                              </use>
                            </svg>
                          </span>
                        </button>
                      </li>
                      {/* // removed swedish - PAR-308 
                     <li className="dropdown__item">
                      <a className="button" onClick={() => this.handleLanguageSelection('en')}>
                        <span className="text">{headerMenuTextKeys.swedish || "Svenska"}</span>
                        <span className="icon">
                          <svg className="svg-icon svg-icon--checkmark">
                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-checkmark" />
                          </svg>
                        </span>
                      </a>
                    </li> */}
                    </ul>
                  </div>
                </li>
                <li className="main-navigation__item search search--desktop js--search-bar">
                  <button className="button button--nav for-search js--search-field-toggle" onClick={() => this.handleSearchToggle()}>
                    <span className="icon">
                      <svg className="svg-icon svg-icon--search-new">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-search-new">
                          &nbsp;
                        </use>
                      </svg>
                    </span>
                    <span className="icon2">
                      <svg className="svg-icon svg-icon--close-new">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                          &nbsp;
                        </use>
                      </svg>
                    </span>
                  </button>
                  <form name="searchForm" action="https://info.parkering.cph.dk/s%C3%B8g?">
                    <div className={`search__field ${isSearchActive ? "is-active" : ""}`}>
                      <input type="text" name="q" id="q" placeholder={headerMenuTextKeys.searchPlaceholder2 || "Søg..."} />
                    </div>
                  </form>
                </li>
              </ul>
            </div>
          </nav>
        </header>
      </div>
    )
  }
}

export default MenuBar
